// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_iU","advertCardNum":"c-a_iV"};